import { forwardRef, ForwardedRef } from 'react';
import cn from 'classnames';
import styles from './checkbox.module.css';

export interface CheckboxProps extends React.HTMLAttributes<HTMLInputElement> {
  label?: string;
  disabled?: boolean;
  name?: string;
}

function Checkbox(
  { label, className, ...props }: CheckboxProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <label className={cn(styles.wrapper, className)}>
      <input className={styles.input} ref={ref} type="checkbox" {...props} />
      <span className={styles.checkbox}>
        <span>+</span>
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
}

export default forwardRef(Checkbox);
